module.exports = __webpack_public_path__ + "img/solistica.58a0f32e.png";